// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventWeeksWithGamesListBody = {
  leagueId: string;
  timeZone: string;
};

export type typeEventWeeksWithGamesListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    seasonId?: string | null;
    timeZone: string;
    weeks: { seasonWeek: number; firstDay: string; lastDay: string }[];
  };
};

export type typeEventWeeksWithGamesListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventWeeksWithGamesListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventWeeksWithGamesListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventWeeksWithGamesListBody = {
  type: "object",
  properties: {
    leagueId: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["leagueId", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventWeeksWithGamesList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventWeeksWithGamesListBody);
  }

  return async function postEventWeeksWithGamesList(
    payload: typeEventWeeksWithGamesListBody,
  ): Promise<
    typeEventWeeksWithGamesListOutput200 | typeEventWeeksWithGamesListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventWeeksWithGamesList" failed before calling the network. #26d878e69bc7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#26d878e69bc7" },
        },
        data: null,
      } as typeEventWeeksWithGamesListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/weeks-with-games-list`,
      httpMethod: "POST",
      options,
    })) as
      | typeEventWeeksWithGamesListOutput200
      | typeEventWeeksWithGamesListOutput400;
  };
}
